import axios from 'axios';
import { BASE_URL } from './Constants';
import { store } from '../index';
import * as actions from '../store/actions/GlobalActions';

const instance = axios.create({
  baseURL: BASE_URL,
});

function onUploadProgress(ev) {}

instance.interceptors.request.use(
  (config) => {
    store.dispatch({
      type: actions.SHOW_LOADING_DIV,
    });
    if (!config.url.includes('login')) {
      config.headers['X-Auth-Token'] = localStorage['auth'];
    }
    return {
      ...config,
      onUploadProgress: config.onUploadProgress || onUploadProgress,
    };
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  function (response) {
    store.dispatch({
      type: actions.HIDE_LOADING_DIV,
    });

    if (response.status === 200 && response.config.method !== 'get') {
      store.dispatch({
        type: actions.SHOW_SUCCESS_TOAST,
        msg: 'Operation successful!',
      });
    }

    return response;
  },
  function (error) {
    store.dispatch({
      type: actions.HIDE_LOADING_DIV,
    });

    if (axios.isCancel(error)) return Promise.reject(new Error('CANCELLED'));

    if (error && error.response) {
      let msg = error.response.data.message || error.response.data;
      if (error.response.status === 401) {
        msg = 'Unauthorized - Wrong Credentials';
      }

      store.dispatch({
        type: actions.SHOW_ERROR_TOAST,
        msg: 'Operation failed - ' + msg,
      });

    }
    return Promise.reject(error.response);
  }
);

export default instance;
